export interface SnackbarInterface {
  visible?: boolean;
  text?: string;
  timeout?: number;
  color?: string;
}

export interface StateInterface {
  snackbar: SnackbarInterface;
}

const state: StateInterface = {
  snackbar: {
    visible: false,
    text: "",
    timeout: 6000,
  },
};

export default state;
